import "./DifynWorkbench.css";

const metrics = [
  { label: "Reports waiting", value: "7", tone: "purple" },
  { label: "Follow-ups due", value: "12", tone: "blue" },
  { label: "High-risk changes", value: "3", tone: "red" },
  { label: "Reviews this week", value: "18", tone: "green" },
];

const pipeline = [
  { label: "Uploaded", value: 5 },
  { label: "Comparing", value: 2 },
  { label: "Needs review", value: 7 },
  { label: "Ready to send", value: 4 },
];

const risks = [
  {
    title: "Specified item removed",
    client: "Demo Client",
    detail: "Jewellery item appears on the old schedule but not the new one.",
    level: "High risk",
  },
  {
    title: "Premium increase over 15%",
    client: "Renewal Review",
    detail: "Monthly premium increased without a clear cover increase.",
    level: "Review",
  },
  {
    title: "Excess changed",
    client: "Household Policy",
    detail: "Vehicle excess increased from previous schedule.",
    level: "Check",
  },
];

const followUps = [
  {
    action: "Call client about removed specified item",
    owner: "Broker",
    due: "Today",
  },
  {
    action: "Send comparison report for approval",
    owner: "Admin",
    due: "Today",
  },
  {
    action: "Request missing schedule page",
    owner: "Client",
    due: "Tomorrow",
  },
];

const clients = [
  {
    name: "Demo Client",
    policy: "Personal Lines Renewal",
    status: "Report waiting",
    note: "2 high-risk findings",
  },
  {
    name: "Household Policy",
    policy: "Home + Contents",
    status: "Needs review",
    note: "Missing specified item confirmation",
  },
  {
    name: "Renewal Review",
    policy: "Motor + Household",
    status: "Ready to send",
    note: "Client wording generated",
  },
];

const activity = [
  "Old and new schedules uploaded",
  "Difyn detected 14 policy changes",
  "Client-friendly report drafted",
  "Follow-up created for removed item",
];

export const DifynWorkbench = () => {
  const today = new Date().toLocaleDateString("en-ZA", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return (
    <main className="difyn-workbench">
      <div className="difyn-shell">
        <section className="difyn-topbar">
          <div>
            <p className="difyn-date">{today}</p>
            <h1 className="difyn-title">Difyn Workbench</h1>
            <p className="difyn-lead">
              A smart insurance command centre for clients, policy schedules,
              comparisons, reports, follow-ups and audit history.
            </p>
          </div>

          <div className="difyn-top-actions">
            <button
              className="difyn-button difyn-button-primary"
              onClick={() => alert("Next: build New Policy Review wizard")}
            >
              New Policy Review
            </button>
            <button
              className="difyn-button difyn-button-secondary"
              onClick={() => alert("Next: open client file demo")}
            >
              Open Client File
            </button>
          </div>
        </section>

        <section className="difyn-ai-card">
          <div>
            <p className="difyn-eyebrow">Ask Difyn</p>
            <h2>What needs my attention today?</h2>
            <p>
              Future AI layer: find risky changes, explain policy differences,
              draft client wording and create follow-ups automatically.
            </p>
          </div>

          <div className="difyn-prompt">
            Show me clients with premium increases over 15% and no follow-up.
          </div>
        </section>

        <section className="difyn-metrics">
          {metrics.map((metric) => (
            <div key={metric.label} className={`difyn-metric ${metric.tone}`}>
              <span>{metric.value}</span>
              <p>{metric.label}</p>
            </div>
          ))}
        </section>

        <section className="difyn-grid-main">
          <div className="difyn-panel">
            <div className="difyn-panel-header">
              <div>
                <p className="difyn-eyebrow">Core workflow</p>
                <h2>Policy review pipeline</h2>
              </div>
              <button
                className="difyn-link-button"
                onClick={() => alert("Next: full comparison workflow")}
              >
                View all
              </button>
            </div>

            <div className="difyn-pipeline">
              {pipeline.map((step, index) => (
                <div key={step.label} className="difyn-pipeline-step">
                  <div className="difyn-pipeline-number">{step.value}</div>
                  <div>
                    <strong>{step.label}</strong>
                    <p>Stage {index + 1}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="difyn-flow-strip">
              Client → Policy schedule → Comparison → Report → Follow-up →
              Audit trail
            </div>
          </div>

          <div className="difyn-panel difyn-dark-panel">
            <p className="difyn-eyebrow">Primary action</p>
            <h2>Start a new policy review</h2>
            <p>
              Select or create a client, upload old and new schedules, compare,
              review findings, generate a report and create follow-ups.
            </p>
            <button
              className="difyn-button difyn-button-light"
              onClick={() => alert("Next: wizard screen")}
            >
              Start review
            </button>
          </div>
        </section>

        <section className="difyn-grid-two">
          <div className="difyn-panel">
            <div className="difyn-panel-header">
              <div>
                <p className="difyn-eyebrow">Smart findings</p>
                <h2>High-risk changes</h2>
              </div>
            </div>

            <div className="difyn-list">
              {risks.map((risk) => (
                <div key={risk.title} className="difyn-risk-item">
                  <div>
                    <strong>{risk.title}</strong>
                    <p>{risk.client}</p>
                    <span>{risk.detail}</span>
                  </div>
                  <em>{risk.level}</em>
                </div>
              ))}
            </div>
          </div>

          <div className="difyn-panel">
            <div className="difyn-panel-header">
              <div>
                <p className="difyn-eyebrow">Action queue</p>
                <h2>Follow-ups due</h2>
              </div>
            </div>

            <div className="difyn-list">
              {followUps.map((task) => (
                <div key={task.action} className="difyn-task-item">
                  <strong>{task.action}</strong>
                  <p>
                    {task.owner} · {task.due}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="difyn-grid-two">
          <div className="difyn-panel">
            <div className="difyn-panel-header">
              <div>
                <p className="difyn-eyebrow">Client files</p>
                <h2>Clients needing attention</h2>
              </div>
              <button
                className="difyn-link-button"
                onClick={() => alert("Next: Clients screen")}
              >
                Clients
              </button>
            </div>

            <div className="difyn-client-grid">
              {clients.map((client) => (
                <div key={client.name} className="difyn-client-card">
                  <strong>{client.name}</strong>
                  <p>{client.policy}</p>
                  <span>{client.status}</span>
                  <small>{client.note}</small>
                </div>
              ))}
            </div>
          </div>

          <div className="difyn-panel">
            <div className="difyn-panel-header">
              <div>
                <p className="difyn-eyebrow">Evidence trail</p>
                <h2>Recent activity</h2>
              </div>
            </div>

            <div className="difyn-timeline">
              {activity.map((item) => (
                <div key={item} className="difyn-timeline-item">
                  <i />
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};
